import { divIcon } from "leaflet";
import React from "react";
import { Circle, Marker, Tooltip } from "react-leaflet";

const EmergencyAreaPoints = React.memo(({ emergencyAreaPoints }) => {
    const icon = divIcon({ className: "map-icon--emergency-area-point", iconSize: [18, 18] });
    return (emergencyAreaPoints || []).map((el, index) => <EmergencyAreaPoint key={index} icon={icon} item={el} />);
});

const EmergencyAreaPoint = (props) => {
    const {
        item: { geozone, name, comment },
        icon,
    } = props;
    if (!geozone?.location?.coordinates) {
        return null;
    }
    const position = [...geozone.location.coordinates].reverse();
    return (
        <>
            <Marker position={position} icon={icon}>
                <Tooltip direction="top">
                    <div className="font-weight-bold">{name}</div>
                    <div>{comment}</div>
                </Tooltip>
            </Marker>
            <Circle center={position} radius={geozone.radius || 200} color="#e5443c" />;
        </>
    );
};

const MemoizedEmergencyAreaPoints = (props) => <EmergencyAreaPoints {...props} />;

export default MemoizedEmergencyAreaPoints;
